import clsx from 'clsx';
import { Outlet } from 'react-router-dom';
import { useHeaderAuth } from '../../features/auth/hooks/useHeaderAuth';
import { TopBar } from '../../widgets/top-bar/TopBar';
import { useIsScreenTooSmall } from '../../shared/hooks';
import { ScreenTooSmall } from '../../shared/ui/screen-too-small/ScreenTooSmall';
import styles from './AppLayout.module.css';

export function AppLayout() {
  const { displayName, tenantName, logoutToRoot } = useHeaderAuth();
  const isScreenTooSmall = useIsScreenTooSmall();

  if (isScreenTooSmall) {
    return <ScreenTooSmall />;
  }

  return (
    <div className={clsx(styles.shell)}>
      <TopBar userName={displayName} tenantName={tenantName} onLogout={logoutToRoot} />
      <Outlet />
    </div>
  );
}
